import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import classNames from "classnames";
import { Icon, Group } from "@/comn/components";
import ReactECharts from "echarts-for-react";
import { useAuth } from "@/comn/hooks";
import { api } from "@/comn";
import { comnUtils } from "@/comn/utils";

// import axios from "axios";
// const api = axios.create({ baseURL: process.env.REACT_APP_API_PTLO });

const TanogaPortalMainNotice = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const menuBoardMap =
        // { menuId: "menu_ptlo0008", bltbrdId: "17835952-5e3f-29f3-e063-020011ac31b7" }; //정부 공지사항 (MY PORTAL)
        { menuId: "menu_ptlo0026", bltbrdId: "17613ff3-479d-7ebf-e063-020011acc580" }; //Q&A (포탈관리)

    const [foundNotice, setNotice] = useState<any[]>([]);

    const getNoticeList = async () => {
        try {
            let base = "",
                path = "",
                query = "";

            switch (process.env.REACT_APP_SYSTEM_GROUP) {
                case "tanoga":
                    base = process.env.REACT_APP_API_PTLO || "";
                    path = `/api/v1/ptlo/comn/comn/main/notice`;
                    query = "?bltbrdUuid=" + menuBoardMap.bltbrdId;
                    break;
            }
            const response = await api.get(base + path + query);
            const data = response.data.ogaNtcList.content;
            setNotice(data);
        } catch (error) {
            console.log(error);
            // throw error;
        }
    };

    useEffect(() => {
        getNoticeList();
    }, []);

    return (
        <div className="col-span-8 sm:col-span-1">
            <Group height="100%">
                <Group.Header>{t("L_OGA_ORG_NTC")}</Group.Header>
                <Group.Body>
                    <div className="board-body noti-wrap p-[20px] box-border h-auto lg:h-[calc(100%-45px)]">
                        <div className="noti-min flex flex-col gap-[12px] h-full">
                            {foundNotice &&
                                foundNotice.map((notice, index) =>
                                    index === 0 ? (
                                        <div className="noti-head flex flex-col gap-[5px]" key={index}>
                                            <div className="noti-title flex justify-between items-center">
                                                <a
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        navigate(
                                                            `/ptlo/cmnty/btbdms/ptlo1018001q/${notice.bltbrdUuid}/${notice.btbdmsId}?menuId=menu_ptle0021`,
                                                        );
                                                    }}
                                                    className="text-primary underline"
                                                    style={{ cursor: "pointer" }}
                                                >
                                                    <h4 className="text-base">{notice.btbdmsTtleNm}</h4>
                                                </a>
                                                <div className="flex justify-end gap-[20px]">
                                                    <p className="font-semibold">{notice.frstRegstId}</p>
                                                    <span className="text-darkgray">{notice.frstRgsrDtm}</span>
                                                </div>
                                            </div>
                                            <div className="noti-text line-clamp-2">
                                                <div dangerouslySetInnerHTML={{ __html: notice.btbdmsCn }} />
                                            </div>
                                        </div>
                                    ) : (
                                        <div key={index}>
                                            {index === 1 && (
                                                <>
                                                    <b className="w-full h-[1px] block bg-card-border"></b>
                                                    <div className="noti-list h-full">
                                                        <ul className="w-full h-full flex flex-col gap-[5px] justify-between">
                                                            {foundNotice.slice(1).map((notice, idx) => (
                                                                <li
                                                                    key={idx}
                                                                    className="w-full flex justify-between text-darkgray relative pl-[10px] after:content-[''] after:absolute after:block after:w-[4px] after:h-[4px] after:bg-primary after:rounded-[5px] after:top-[5px] after:left-0"
                                                                >
                                                                    <a
                                                                        onClick={(e) => {
                                                                            e.preventDefault();
                                                                            navigate(
                                                                                `/ptlo/cmnty/btbdms/ptlo1018001q/${menuBoardMap.bltbrdId}/${notice.btbdmsId}?menuId=menu_ptle0021`,
                                                                            );
                                                                        }}
                                                                        className="text-primary underline w-4/5 line-clamp-2"
                                                                        style={{ cursor: "pointer" }}
                                                                    >
                                                                        {notice.btbdmsTtleNm}
                                                                    </a>
                                                                    <span className="text-right">
                                                                        {notice.frstRgsrDtm}
                                                                    </span>
                                                                </li>
                                                            ))}
                                                        </ul>
                                                    </div>
                                                </>
                                            )}
                                        </div>
                                    ),
                                )}
                        </div>
                    </div>
                </Group.Body>
            </Group>
        </div>
    );
};

const TanogaPortalMainNotification = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const [foundNotification, setNotification] = useState<any[]>([]);

    const getNotificationList = async () => {
        try {
            let base = "",
                path = "";

            switch (process.env.REACT_APP_SYSTEM_GROUP) {
                case "tanoga":
                    base = process.env.REACT_APP_API_PTLO || "";
                    path = `/api/v1/ptlo/comn/comn/main/notification`;
                    break;
            }
            const response = await api.get(base + path);
            const data = response.data.notificationList.content;
            setNotification(data);
        } catch (error) {
            console.log(error);
            // throw error;
        }
    };

    useEffect(() => {
        getNotificationList();
    }, []);

    return (
        <div className={classNames("dashboard-content-min w-full flex gap-[20px] flex-grow-[1] flex-col")}>
            <div className="board-content flex-grow-[1] agency-board w-full bg-card rounded-[5px] overflow-hidden shadow-md flex flex-col justify-between border-[1px]">
                <div className="board-head bg-header flex justify-between items-center px-[20px] py-[10px] box-border border-b-[1px] border-card-border">
                    <p className="flex gap-[10px] items-center">
                        <h3 className="text-base">{t("T_TOT_NTC_LST")}</h3>
                        {/* <span className="text-darkgray">나의 할일과 결재 현황</span> */}
                    </p>
                </div>
                <div className="board-body p-[20px] box-border h-full">
                    {foundNotification &&
                        foundNotification.map((notification, index) => (
                            <div className="noti-head flex flex-col gap-[10px]">
                                <div className="noti-title flex gap-[4px] justify-between items-center flex-wrap">
                                    <a
                                        onClick={(e) => {
                                            e.preventDefault();
                                            navigate(
                                                `/ptlo/ptl/btbdms/ptli1018002q/${notification.bltbrdUuid}/${notification.btbdmsId}?menuId=menu_ptlo0021`,
                                            );
                                        }}
                                    >
                                        <h4>{notification.btbdmsTtleNm}</h4>
                                    </a>
                                    <div style={{ display: "flex", gap: "20px" }}>
                                        <p style={{ fontWeight: "bold", margin: 0 }}>{notification.selcCnt}</p>
                                        <p style={{ fontWeight: "bold", margin: 0 }}>{notification.frstRegstId}</p>
                                        <span style={{ color: "#888888", whiteSpace: "nowrap" }}>
                                            {notification.frstRgsrDtm}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        ))}
                </div>
            </div>
        </div>
    );
};

const TanogaPortalMainInsc = () => {
    const auth: any = useAuth(); // Login , User Information Hook !== 로그인, 유저정보 Hook ==!
    const [totInscCnt, setTotInscCnt] = useState<any[]>([]);
    const [prcdInscCnt, setPrcdInscCnt] = useState<any[]>([]);
    const [doneInscCnt, setDoneInscCnt] = useState<any[]>([]);
    const { t } = useTranslation();

    const getTotInscCnt = async () => {
        try {
            let base = "",
                path = "";

            switch (process.env.REACT_APP_SYSTEM_GROUP) {
                case "tanoga":
                    base = process.env.REACT_APP_API_PTLO || "";
                    path = `/api/v1/ptlo/ogaptl/esw/insc/tot-insc-cnt`;
                    break;
            }

            const paramData = {
                srchOrgCd: auth.get("orgCd"),
                srchUsrId: auth.get("usrId"),
            };

            const response = await api.get(base + path, {
                params: comnUtils.toGetParams(paramData),
            });

            const data = response.data.totInscCnt.content;
            let chartData: any = [];

            Object.entries(data).forEach((value) => {
                if (value[0].indexOf("Cnt") > 0) {
                    chartData.push({ value: value[1] });
                }
            });

            setTotInscCnt(chartData);
        } catch (error) {
            console.log(error);
            // throw error;
        }
    };

    const getPrcdInscCnt = async () => {
        try {
            let base = "",
                path = "";

            switch (process.env.REACT_APP_SYSTEM_GROUP) {
                case "tanoga":
                    base = process.env.REACT_APP_API_PTLO || "";
                    path = `/api/v1/ptlo/ogaptl/esw/insc/prcd-insc-cnt`;
                    break;
            }

            const paramData = {
                srchOrgCd: auth.get("orgCd"),
                srchUsrId: auth.get("usrId"),
            };

            const response = await api.get(base + path, {
                params: comnUtils.toGetParams(paramData),
            });

            const data = response.data.prcdInscCnt.content;
            let chartData: any = [];

            Object.entries(data).forEach((value) => {
                if (value[0].indexOf("Cnt") > 0) {
                    chartData.push({ value: value[1] });
                }
            });

            setPrcdInscCnt(chartData);
        } catch (error) {
            console.log(error);
            // throw error;
        }
    };

    const getDoneInscCnt = async () => {
        try {
            let base = "",
                path = "";

            switch (process.env.REACT_APP_SYSTEM_GROUP) {
                case "tanoga":
                    base = process.env.REACT_APP_API_PTLO || "";
                    path = `/api/v1/ptlo/ogaptl/esw/insc/done-insc-cnt`;
                    break;
            }

            const paramData = {
                srchOrgCd: auth.get("orgCd"),
                srchUsrId: auth.get("usrId"),
            };

            const response = await api.get(base + path, {
                params: comnUtils.toGetParams(paramData),
            });

            const data = response.data.doneInscCnt.content;
            let chartData: any = [];

            Object.entries(data).forEach((value) => {
                if (value[0].indexOf("Cnt") > 0) {
                    chartData.push({ value: value[1] });
                }
            });

            setDoneInscCnt(chartData);
        } catch (error) {
            console.log(error);
            // throw error;
        }
    };

    useEffect(() => {
        getTotInscCnt();
        getPrcdInscCnt();
        getDoneInscCnt();
    }, []);

    return (
        <div className="flex-grow-[1] w-full bg-card rounded-[5px] overflow-hidden shadow-md flex flex-col justify-between border-[1px]">
            <div className="board-head bg-header flex justify-between items-center px-[20px] py-[10px] box-border border-b-[1px] border-card-border">
                <h3 className="text-base">Joint Inspection Processing Status</h3>
            </div>
            <div className="p-[20px] box-border h-full">
                <ul className="grid grid-cols-1 w-full h-full gap-[30px]">
                    <li className="flex flex-col justify-start items-start gap-[10px]">
                        {/* <h4>{t("L_AL_APP_CNT")}</h4> */}
                        <div className="border border-1 border-lightgray w-full h-full">
                            <ReactECharts
                                option={{
                                    tooltip: {
                                        trigger: "axis",
                                        axisPointer: { type: "cross" },
                                    },
                                    xAxis: {
                                        type: "category",
                                        data: [
                                            t("L_JAN"),
                                            t("L_FEB"),
                                            t("L_MAR"),
                                            t("L_APR"),
                                            t("L_MAY"),
                                            t("L_JUN"),
                                            t("L_JUL"),
                                            t("L_AUG"),
                                            t("L_SEP"),
                                            t("L_OCT"),
                                            t("L_NOV"),
                                            t("L_DEC"),
                                        ],
                                        axisLabel: {
                                            fontSize: 10,
                                            interval: 0,
                                            rotate: 30,
                                        },
                                    },
                                    yAxis: {
                                        type: "value",
                                    },
                                    series: [
                                        {
                                            type: "bar",
                                            barWidth: "15%",
                                            data: totInscCnt,
                                            name: t("L_TOT_CNT"),
                                        },
                                        {
                                            type: "bar",
                                            barWidth: "15%",
                                            data: prcdInscCnt,
                                            name: t("L_INSC_PRCD_CNT"),
                                            backgroundStyle: {
                                                color: "rgba(180, 180, 180, 0.2)",
                                            },
                                            itemStyle: {
                                                borderRadius: [0, 0, 0, 0],
                                                borderColor: "#f4645e",
                                                color: "#f4645e",
                                            },
                                        },
                                        {
                                            type: "bar",
                                            barWidth: "15%",
                                            data: doneInscCnt,
                                            name: t("L_INSC_DONE_CNT"),
                                        },
                                    ],
                                }}
                            />
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    );
};

const TanogaPortalMainLPCO = () => {
    const auth: any = useAuth(); // Login , User Information Hook !== 로그인, 유저정보 Hook ==!
    const [totAppCnt, setTotAppCnt] = useState<any[]>([]);
    const [prcdAppCnt, setPrcdAppCnt] = useState<any[]>([]);
    const [doneAppCnt, setDoneAppCnt] = useState<any[]>([]);
    const { t } = useTranslation();

    const getTotAppCnt = async () => {
        try {
            let base = "",
                path = "";

            switch (process.env.REACT_APP_SYSTEM_GROUP) {
                case "tanoga":
                    base = process.env.REACT_APP_API_PTLO || "";
                    path = `/api/v1/ptlo/ogaptl/esw/lpco/tot-app-cnt`;
                    break;
            }
            const paramData = {
                srchOrgCd: auth.get("orgCd"),
                srchUsrId: auth.get("usrId"),
            };

            const response = await api.get(base + path, {
                params: comnUtils.toGetParams(paramData),
            });

            const data = response.data.totAppCnt.content;
            let chartData: any = [];

            Object.entries(data).forEach((value) => {
                if (value[0].indexOf("Cnt") > 0) {
                    chartData.push({ value: value[1] });
                }
            });

            setTotAppCnt(chartData);
        } catch (error) {
            console.log(error);
            // throw error;
        }
    };

    const getPrcdAppCnt = async () => {
        try {
            let base = "",
                path = "";

            switch (process.env.REACT_APP_SYSTEM_GROUP) {
                case "tanoga":
                    base = process.env.REACT_APP_API_PTLO || "";
                    path = `/api/v1/ptlo/ogaptl/esw/lpco/prcd-app-cnt`;
                    break;
            }
            const paramData = {
                srchOrgCd: auth.get("orgCd"),
                srchUsrId: auth.get("usrId"),
            };

            const response = await api.get(base + path, {
                params: comnUtils.toGetParams(paramData),
            });

            const data = response.data.prcdAppCnt.content;
            let chartData: any = [];

            Object.entries(data).forEach((value) => {
                if (value[0].indexOf("Cnt") > 0) {
                    chartData.push({ value: value[1] });
                }
            });

            setPrcdAppCnt(chartData);
        } catch (error) {
            console.log(error);
            // throw error;
        }
    };

    const getDoneAppCnt = async () => {
        try {
            let base = "",
                path = "";

            switch (process.env.REACT_APP_SYSTEM_GROUP) {
                case "tanoga":
                    base = process.env.REACT_APP_API_PTLO || "";
                    path = `/api/v1/ptlo/ogaptl/esw/lpco/done-app-cnt`;
                    break;
            }
            const paramData = {
                srchOrgCd: auth.get("orgCd"),
                srchUsrId: auth.get("usrId"),
            };

            const response = await api.get(base + path, {
                params: comnUtils.toGetParams(paramData),
            });

            const data = response.data.doneAppCnt.content;
            let chartData: any = [];

            Object.entries(data).forEach((value) => {
                if (value[0].indexOf("Cnt") > 0) {
                    chartData.push({ value: value[1] });
                }
            });

            setDoneAppCnt(chartData);
        } catch (error) {
            console.log(error);
            // throw error;
        }
    };

    useEffect(() => {
        getTotAppCnt();
        getPrcdAppCnt();
        getDoneAppCnt();
    }, []);

    return (
        // <div className="w-full grid grid-cols-1 lg:grid-cols-2 gap-[20px]">
        <div className="flex-grow-[1] w-full bg-card rounded-[5px] overflow-hidden shadow-md flex flex-col justify-between border-[1px]">
            <div className="board-head bg-header flex justify-between items-center px-[20px] py-[10px] box-border border-b-[1px] border-card-border">
                <h3 className="text-base">LPCO Processing Status</h3>
            </div>
            <div className="p-[20px] box-border h-full">
                <ul className="grid grid-cols-1 w-full h-full gap-[30px]">
                    <li className="flex flex-col justify-start items-start gap-[10px]">
                        {/* <h4>{t("L_AL_APP_CNT")}</h4> */}
                        <div className="border border-1 border-lightgray w-full h-full">
                            <ReactECharts
                                option={{
                                    tooltip: {
                                        trigger: "axis",
                                        axisPointer: { type: "cross" },
                                    },
                                    xAxis: {
                                        type: "category",
                                        data: [
                                            t("L_JAN"),
                                            t("L_FEB"),
                                            t("L_MAR"),
                                            t("L_APR"),
                                            t("L_MAY"),
                                            t("L_JUN"),
                                            t("L_JUL"),
                                            t("L_AUG"),
                                            t("L_SEP"),
                                            t("L_OCT"),
                                            t("L_NOV"),
                                            t("L_DEC"),
                                        ],
                                        axisLabel: {
                                            fontSize: 10,
                                            interval: 0,
                                            rotate: 30,
                                        },
                                    },
                                    yAxis: {
                                        type: "value",
                                    },
                                    series: [
                                        {
                                            type: "bar",
                                            barWidth: "15%",
                                            data: totAppCnt,
                                            name: t("L_TOT_CNT"),
                                        },
                                        {
                                            type: "bar",
                                            barWidth: "15%",
                                            data: prcdAppCnt,
                                            name: t("L_APP_PRCD_CNT"),
                                            backgroundStyle: {
                                                color: "rgba(180, 180, 180, 0.2)",
                                            },
                                            itemStyle: {
                                                borderRadius: [0, 0, 0, 0],
                                                borderColor: "#f4645e",
                                                color: "#f4645e",
                                            },
                                        },
                                        {
                                            type: "bar",
                                            barWidth: "15%",
                                            data: doneAppCnt,
                                            name: t("L_APP_DONE_CNT"),
                                        },
                                    ],
                                }}
                            />
                        </div>
                    </li>
                </ul>
            </div>
        </div>
        // </div>
    );
};

const TanogaPortalMainTodo = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const [foundTodo, setTodo] = useState<any[]>([]);

    const handleMoveTodoDtl = (todo: any) => {
        if (todo.todoReffId !== null) {
            if (todo.todoReffId.charAt(0) !== "/") {
                todo.todoReffId = "/" + todo.todoReffId;
            }
        }
        const scrnDocUrlAddr = todo.scrnDocUrlAddr + todo.todoReffId;

        let frontDmn;
        const getBsopClsfCd = todo.bsopClsfCd;

        if (getBsopClsfCd == "PTL") {
            frontDmn = process.env.REACT_APP_API_FRONT_PTLO;
        } else if (getBsopClsfCd == "ESW") {
            frontDmn = process.env.REACT_APP_API_FRONT_ESWO;
        }

        // 추후 삭제 할 것 (도메인 동일함)
        todo.todoReffId.indexOf("?") === -1
            ? window.open(
                  `${frontDmn}${scrnDocUrlAddr}?menuId=mytodo&ptlTodoPrcdStatCd=${todo.ptlTodoPrcdStatCd}`,
                  "_parent",
              )
            : window.open(
                  `${frontDmn}${scrnDocUrlAddr}&menuId=mytodo&ptlTodoPrcdStatCd=${todo.ptlTodoPrcdStatCd}`,
                  "_parent",
              );
        // window.open(`/ptli/usr/cstm/ptli0901003s/TZGT?todoReffVal1=11&menuId=mytodo`, "_parent");

        // 추후 사용할 것
        // const param = rowValues.todoReffVal;
        // navigate(`/ptli/usr/cstm/ptli0901003s/TZGT`, { state: { todoReffVal1: "111" } });
    };

    const getTodoList = async () => {
        try {
            let base = "",
                path = "";

            switch (process.env.REACT_APP_SYSTEM_GROUP) {
                case "tanoga":
                    base = process.env.REACT_APP_API_PTLO || "";
                    path = `/api/v1/ptlo/comn/comn/main/todo`;
                    break;
            }
            const response = await api.get(base + path);
            const data = response.data.todoList.content;
            setTodo(data);
        } catch (error) {
            console.log(error);
            // throw error;
        }
    };

    useEffect(() => {
        getTodoList();
    }, []);

    return (
        <div className={classNames("dashboard-content-min w-full flex gap-[20px] flex-grow-[1] flex-col")}>
            <div className="board-content flex-grow-[1] agency-board w-full bg-card rounded-[5px] overflow-hidden shadow-md flex flex-col justify-between border-[1px]">
                <div className="board-head bg-header flex justify-between items-center px-[20px] py-[10px] box-border border-b-[1px] border-card-border">
                    <div className="flex gap-[10px] items-center">
                        <h3 className="text-base">{t("T_MY_TODO")}</h3>
                    </div>
                </div>
                <div className="board-body p-[20px] box-border h-full">
                    <ul className="w-full h-auto flex flex-col gap-[16px] justify-start ">
                        {foundTodo?.map((todo, index) => (
                            <li
                                key={index}
                                className="w-full flex justify-between text-darkgray relative pl-[10px] after:content-[''] after:absolute after:block after:w-[4px] after:h-[4px] after:bg-primary after:rounded-[5px] after:top-[5px] after:left-0"
                            >
                                <a
                                    onClick={(e) => {
                                        e.preventDefault();
                                        handleMoveTodoDtl(todo);
                                    }}
                                    className="text-primary underline w-4/5 line-clamp-2"
                                    style={{ cursor: "pointer" }}
                                >
                                    {todo.todoBsopDvn}
                                </a>
                                <span className="text-right">{todo.frstRgsrDtm}</span>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </div>
    );
};

const TanogaPortalMain = () => {
    return (
        <div className="dashboard-wrapper h-auto lg:h-[calc(100vh-145px)]" style={{ width: "100%" }}>
            <div className="dashboard-wrap flex flex-col lg:flex-row gap-[20px] h-full" style={{ width: "100%" }}>
                <div
                    className="dashboard-content-wrap w-full lg:w-3/4 h-full flex flex-col gap-[20px] justify-between"
                    style={{ width: "100%" }}
                >
                    <TanogaPortalMainNotice />
                    <div className="w-full grid grid-cols-1 lg:grid-cols-2 gap-[20px]">
                        <TanogaPortalMainLPCO />
                        <TanogaPortalMainInsc />
                    </div>
                    <TanogaPortalMainTodo />
                </div>
            </div>
        </div>
    );
};

export default TanogaPortalMain;
